module.exports = __webpack_public_path__ + "img/emoji-rating.ce1db4ec.jpg";